import React, { useState, useContext, useEffect } from 'react';
import { IconButton, Menu, MenuItem, Avatar, Typography, Box, Divider, Tooltip } from '@mui/material';
import { Context } from '../../App';
import { useNavigate } from 'react-router-dom';

const AccountMenu = () => {
    const navigate = useNavigate();
    const { isConnected, setIsConnected, userId, setUserId } = useContext(Context);
    const [user, setUser] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleDeconnect = () => {
        handleClose();
        // Clear user data and local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userData');
        setIsConnected(false);
        setUserId(localStorage.getItem('anonUserId') || null);
        setUser(null);
    }

    useEffect(() => {
        // Charger les données utilisateur depuis localStorage
        const userData = localStorage.getItem('userData');
        console.log(process.env.REACT_APP_ADM_WEB_APP_URL);
        if (userData && isConnected) {
            try {
                const parsedUser = JSON.parse(userData);
                setUser(parsedUser);
            } catch (error) {
                console.error('Error parsing user data:', error);
                localStorage.removeItem('userData');
                setIsConnected(false);
            }
        } else if (!userData && isConnected) {
            // Si pas de données utilisateur mais marqué comme connecté, déconnecter
            setIsConnected(false);
        }
    }, [isConnected, userId, setIsConnected]);

    return (
        <>
        {!!user && <Tooltip title="Mon compte">
            <IconButton
            onClick={handleOpen}
            onMouseEnter={handleOpen}
            size="large"
            edge="end"
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            >
            <Avatar 
                src={user.photoUrl} 
                alt={`${user.prenom} ${user.nom}`}
                sx={{ width: 42, height: 42, bgcolor: 'focus.main', color:'white', fontSize: 16, fontWeight:'bold' }}
            >
                {!user.photoUrl && (user.nom.charAt(0) + user.prenom.charAt(0)).toUpperCase()}
            </Avatar>
            </IconButton>
        </Tooltip>}

        <Menu
            id="account-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onMouseLeave={handleClose}
            slotProps={{ list: { onMouseLeave: handleClose} }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            {/* En-tête utilisateur */}
            <Box px={2} py={1}>
                <Typography variant="body2" color="text.secondary" fontWeight="bold">
                    Connecté en tant que :
                </Typography>
                <Typography variant="body2" color="text.primary">
                    {user?.mail}
                </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            {/* Liens du menu */}
            <MenuItem onClick={()=>{handleClose(); navigate('/compte')}}>Mon compte</MenuItem>
            <MenuItem onClick={()=>{handleClose(); navigate('/mes_recus')}}>Mes reçus</MenuItem>

            {user?.role!=='user' && (
            <MenuItem onClick={handleClose} sx={{ fontWeight: 'bold' }}>
                <a href={process.env.REACT_APP_ADM_WEB_APP_URL} style={{textDecoration: 'none', color:'inherit'}}>Administration</a>
            </MenuItem>
            )}

            <Divider sx={{ my: 1 }} />

            <MenuItem onClick={handleDeconnect}>Se déconnecter</MenuItem>
        </Menu>
        </>
    );
};

export default AccountMenu;
